







import {Component, Prop, Vue} from "vue-property-decorator";
import ActionsDropdown from "@/componentsReusable/dropdowns/ActionsDropdown.vue";

@Component({
  components: {
    ActionsDropdown
  }
})
export default class Personalization extends Vue {
  @Prop({ type: String, required: true })
  private textElementId!: string;
  @Prop({ type: String, required: true })
  private message!: string;

  private showActions = false;
  private actions = [
    { id: 1, name: 'Contact First Name', result: '{ContactFirstName}' },
    { id: 2, name: 'Contact Last Name', result: '{ContactLastName}' }
  ];
  private cursorLocation = 0;

  toggleActions() {
    const element = document.getElementById(this.textElementId) as HTMLInputElement;
    this.cursorLocation = !element ? 0 : element.selectionStart;
    this.showActions = !this.showActions;
  }

  selectPersonalization(selectedId: number) {
    this.showActions = false;
    const personalization = this.actions.find(action => action.id === selectedId)!.result;

    let newMessage;
    if (this.cursorLocation >= this.message.length) {
      newMessage = this.message + personalization;
    } else {
      const firstPart = this.message.substring(0, this.cursorLocation);
      const lastPart = this.message.substring(this.cursorLocation);
      newMessage = firstPart + personalization + lastPart;
    }

    this.cursorLocation += personalization.length;

    this.$emit('personalization', newMessage);

    // Need to focus in the next tick because this is called during a mouse click event which has a mouse up event following which otherwise resets focus.
    this.$nextTick(() => {
      const element = document.getElementById(this.textElementId) as HTMLInputElement;
      if (element) {
        element.focus();
        element.setSelectionRange(this.cursorLocation, this.cursorLocation);
      }
      this.cursorLocation = 0;
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/communications/components/Personalization.vue